const Skeleton = ({
  variant = "block", // "block" | "header"
  width = "100%",
  height = 16,
  radius = 6,
  style = {},
}) => {
  return (
    <>
      {/* All keyframes in ONE place */}
      <style>
        {`
          @keyframes skeletonShimmer {
            0% { background-position: -200% 0; }
            100% { background-position: 200% 0; }
          }

          @keyframes headerFadeSlide {
            0% {
              opacity: 0;
              transform: translateY(-6px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>

      {variant === "header" ? (
        /* HEADER SKELETON */
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            animation: "headerFadeSlide 0.35s ease-out",
          }}
        >
          {/* LEFT */}
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <div
              style={{
                width: 20,
                height: 20,
                borderRadius: 4,
                background: "linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 37%, #e5e7eb 63%)",
                backgroundSize: "200% 100%",
                animation: "skeletonShimmer 1.4s ease-in-out infinite",
              }}
            />

            <div
              style={{
                width: 44,
                height: 44,
                borderRadius: 12,
                background: "linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 37%, #e5e7eb 63%)",
                backgroundSize: "200% 100%",
                animation: "skeletonShimmer 1.4s ease-in-out infinite",
              }}
            />

            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <div
                style={{
                  width: 180,
                  height: 16,
                  borderRadius: 6,
                  background: "linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 37%, #e5e7eb 63%)",
                  backgroundSize: "200% 100%",
                  animation: "skeletonShimmer 1.4s ease-in-out infinite",
                }}
              />
              <div
                style={{
                  width: 260,
                  height: 12,
                  borderRadius: 6,
                  background: "linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 37%, #e5e7eb 63%)",
                  backgroundSize: "200% 100%",
                  animation: "skeletonShimmer 1.4s ease-in-out infinite",
                }}
              />
            </div>
          </div>

          {/* RIGHT */}
          <div style={{ display: "flex", gap: 12 }}>
            <div
              style={{
                width: 96,
                height: 40,
                borderRadius: 10,
                background: "linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 37%, #e5e7eb 63%)",
                backgroundSize: "200% 100%",
                animation: "skeletonShimmer 1.4s ease-in-out infinite",
              }}
            />
            <div
              style={{
                width: 144,
                height: 40,
                borderRadius: 10,
                background: "linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 37%, #e5e7eb 63%)",
                backgroundSize: "200% 100%",
                animation: "skeletonShimmer 1.4s ease-in-out infinite",
              }}
            />
          </div>
        </div>
      ) : (
        /* NORMAL SKELETON BLOCK */
        <div className="mb-4 rounded overflow-x-hidden border border-gray-200">
          {/* HEADER */}
          <div className="flex items-center h-10 border-b px-2 gap-3">
            {/* Drag handle / title */}
            <div className="h-4 w-40 bg-gray-200 rounded animate-pulse" />

            {/* Helper text */}
            <div className="h-3 w-32 bg-gray-100 rounded animate-pulse" />

            {/* Spacer */}
            <div className="flex-1" />

            {/* Action icons */}
            <div className="flex gap-2">
              <div className="h-6 w-6 bg-gray-200 rounded animate-pulse" />
              <div className="h-6 w-6 bg-gray-200 rounded animate-pulse" />
            </div>
          </div>

          {/* INPUTS GRID */}
          <div className="max-h-[30.5vh] grid grid-cols-2 gap-2 p-2 overflow-hidden">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="flex w-full border border-gray-200 rounded overflow-hidden animate-pulse">
                {/* Left label */}
                <div className="w-1/4 h-10 bg-gray-200" />

                {/* Right content */}
                <div className="flex-1 h-10 bg-gray-100" />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default Skeleton;
